var map = {
	"./border1.png": "09a4",
	"./border2.png": "cd8d",
	"./btn-active.png": "510a",
	"./btn.png": "e6e4",
	"./icon1.png": "eda1",
	"./icon2.png": "e405",
	"./icon3.png": "9387",
	"./icon4.png": "54c3",
	"./icon5.png": "aa23",
	"./icon6.png": "314f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9ec1";